import { RefetchOptions } from '@tanstack/react-query'

import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'

import OperatorWithdrawalTable from '../OperatorWithdrawalTable'

import type { OperatorWithdrawalTransaction } from '@/modules/bank/type'

interface OperatorWithdrawalListingProps {
	data: OperatorWithdrawalTransaction[]
	total: number
	onRefresh: (options?: RefetchOptions) => Promise<unknown>
	isLoading?: boolean
	onSort?: (columnId: string, order: 'asc' | 'desc' | undefined) => void
}

export default function OperatorWithdrawalListing({
	data,
	total,
	onRefresh,
	isLoading,
	onSort,
}: OperatorWithdrawalListingProps) {
	return (
		<div className="space-y-4 px-4 sm:px-0">
			{/* Header Section - Mobile Responsive */}
			<div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
				{/* Title */}
				<div className="space-y-3 sm:space-y-4">
					<Heading
						title="รายการถอนผ่านธนาคารออโต้"
						description="รายการถอนผ่านธนาคารออโต้"
					/>
				</div>

				{/* Date Controls - Mobile Responsive */}
				<div className="flex flex-col gap-3 sm:items-end sm:gap-4">
					<DateRangePicker />
					<DateRangeButtons />
				</div>
			</div>

			<Separator className="my-4 sm:my-6" />

			{/* Table Section */}
			<OperatorWithdrawalTable
				data={data}
				total={total}
				onRefresh={onRefresh}
				isLoading={isLoading}
				onSort={onSort}
			/>
		</div>
	)
}
